const settings = {
	// host: 'http://localhost:3000/api/v1'
	// host: 'https://stage.surveybot.io/api/v1'
	host: 'https://surveybot.io/api/v1'
};

export default settings;


// WEBPACK FOOTER //
// ./src/settings.js